import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ProjectList } from "../Data/ProjectsList";

type ProjectsProps = { isSmallScreen: boolean };

function Projects(_props: ProjectsProps) {
  const theme = useTheme();
  const projects = ProjectList();

  return (
    <Box sx={{ py: 6 }}>
      <Typography variant="h1" fontWeight={700}>
        Shipped{" "}
        <span style={{ color: theme.palette.secondary.main }}>Games</span>
      </Typography>
      <Grid container spacing={3}>
        {projects.map((project) => (
          <Grid item xs={12} sm={6} md={4} key={project.id}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.02)" },
              }}
            >
              <CardMedia
                component="img"
                height="180"
                image={project.image}
                alt={project.projectName}
                sx={{ objectFit: "cover" }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h3" sx={{ py: 0, mb: 0.5 }}>
                  {project.projectName}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: theme.palette.secondary.main, mb: 1 }}
                >
                  {project.company} &middot; {project.role} &middot;{" "}
                  {project.date}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  {project.projectDescription}
                </Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  <Chip
                    label={project.engine}
                    size="small"
                    variant="outlined"
                  />
                  <Button
                    size="small"
                    variant="outlined"
                    href={project.officialLink}
                    target="_blank"
                    sx={{
                      borderColor: theme.palette.secondary.main,
                      textTransform: "none",
                    }}
                  >
                    Official
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Projects;
